module.exports = __webpack_public_path__ + "static/media/iqra6.a4ada3ba.jpg";